import PageRenderer from "../components/PageRenderer";

const Lions = () => <PageRenderer pageName="Lions" />;

export default Lions;
